import { useDeleteItem } from '@api/generics';
import API_ROUTES from '@api/routes';
import { ItemDeleteDialog } from '@components/DataGrid';
import React from 'react';
import { IRole } from 'types/authorization';
import { IRowActionDialogProps } from 'types/common';

const RoleDeleteDialog: React.FC<IRowActionDialogProps> = ({
	onComplete,
	row
}) => {
	const { id } = row!.row;
	const deleteMutation = useDeleteItem<IRole>(
		id,
		'roles',
		API_ROUTES.v1.roles.delete(id)
	);

	return (
		<ItemDeleteDialog
			onComplete={onComplete}
			row={row}
			questionLabelId="roles.action.delete.dialog.question"
			titleLabelId="roles.action.delete.dialog.header"
			toastLabelPrefix="roles.action.delete.dialog.toast"
			deleteMutation={deleteMutation.mutateAsync}
		/>
	);
};

export default RoleDeleteDialog;
